import React from "react";
// import ClassNames from 'classnames'

class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="Header">
        <h1>
          Clear Your Mind and Supercharge Your Yoga Session with Yoga Flow
        </h1>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/buy/header.js